module.exports = __webpack_public_path__ + "media/backgrounds/k-soma-Q-2EigkW_z0-unsplash-3dfa510e.jpg";